import { Screen } from 'components/screen';
import resetPasswordScreenHTML = require('html-loader!html/reset-password-screen');
import getQueryValue from 'helpers/get-query-value';
import { Errors } from 'errors';

/**
 * Screen to reset password
 */
export class ResetPasswordScreen extends Screen {
  public static readonly screenID: string = 'reset-password';

  public async renderImpl(): Promise<void> {
    this.containerEl.innerHTML = resetPasswordScreenHTML;
  }

  /**
   * Submit password reset. Tries to log the user in on successful reset if we know the login id otherwise show the login page.
   */
  public async submitImpl(): Promise<void> {
    const password = this.getFormValue('password');
    const confirmPassword = this.getFormValue('confirmPassword');

    if (password !== confirmPassword) {
      throw { errorMessage: Errors[Errors.PASSWORD_MISMATCH] };
    }

    // User is automatically logged in if this API call succeeds.
    await this.marinSSO.changePassword({
      newPassword: password,
      passwordResetToken: this.context.passwordResetToken || getQueryValue('passwordResetToken'),
    });
  }

  protected getTitle() {
    return 'Reset Password';
  }
}
